import React, { Component } from "react";
import Table from "../components/Table";
import { connect } from "react-redux";
import { mapKV } from "../utils/map";
import { AppBundleInfoDialog } from "../dialogs/AppBundleInfoDialog";
import { AreYouSureDialog } from "../dialogs/AreYouSureDialog";
import { vrTypesToString } from "../utils/appUtils";
import EditAppBundle from "../containers/EditAppBundle";
import AddAppBundle from "../containers/AddAppBundle";
import Tooltip from "@material-ui/core/Tooltip";
import { deleteAppBundle } from "../redux/actions/appBundleActions";
import { APPBUNDLES, createInfoUrl } from "../utils/routes";

export class appbundlesPage extends Component {
  state = {
    showEditDialog: false,
    showAddDialog: false,
    showAreYouSureDialog: false
  };

  headers = [
    { id: 0, title: "Name", sortable: true },
    { id: 1, title: "Description", sortable: true },
    { id: 2, title: "Apps", sortable: false }
  ];

  extractData = () => {
    let { contentBundles, apps } = this.props;
    let data = [];
    let genericKey = 0;
    mapKV(contentBundles, (key, { name, description = "N/A", appRefs }) => {
      let bundledApps = [];
      if (!!appRefs) {
        appRefs.forEach(appRef => {
          let app = apps[appRef.id];
          if (!app) return;
          bundledApps.push(app);
        });
      }
      let appsSearchingValue = "";
      bundledApps.map(app => (appsSearchingValue += " " + app.title + " " + app.packageName));
      data.push({
        name,
        key,
        row: [
          name,
          description,
          bundledApps.map(app => (
            <Tooltip title={app.title} key={`name-${app.packageName}`}>
              <img src={app.iconUrl} style={{ width: 50, margin: 5 }} key={genericKey++} alt="App Icon" />
            </Tooltip>
          ))
        ],
        searching: [name, description, appsSearchingValue].join(" ")
      });
    });
    return data.sort((a,b)=>a.name.localeCompare(b.name));
  };

  extractApps = ({ appRefs }) => {
    const { apps } = this.props;
    let managedApps = [];
    let externalApps = [];
    let genericKey = 0;
    if (!!appRefs) {
      appRefs.forEach(appRef => {
        if (!apps[appRef.id]) return;
        let { apkUrl, iconUrl, title, packageName, vrTypes } = apps[appRef.id];
        const appData = [
          <img src={iconUrl} style={{ width: 50, margin: 5 }} key={genericKey++} />,
          title,
          packageName,
          vrTypesToString(vrTypes)
        ];
        if (apkUrl) managedApps.push(appData);
        else externalApps.push(appData);
      });
    }

    return { managedApps: managedApps.sort((a,b)=>a[1].localeCompare(b[1])), externalApps: externalApps.sort((a,b)=>a[1].localeCompare(b[1]))};
  };

  render() {
    const { contentBundles, loading, deleteAppBundle } = this.props;
    const { showEditDialog, showAddDialog, showAreYouSureDialog } = this.state;

    const { history, match } = this.props;
    const { selectedKey } = match.params;

    const selectedBundle = contentBundles[selectedKey];
    return (
      <div>
        {showAddDialog && <AddAppBundle onClose={() => this.setState({ showAddDialog: false })} />}

        {showEditDialog && (
          <EditAppBundle
            selectedKey={selectedKey}
            selectedBundle={selectedBundle}
            onClose={() => this.setState({ showEditDialog: false })}
          />
        )}

        {selectedKey && selectedBundle && !showEditDialog && (
          <AppBundleInfoDialog
            appBundle={selectedBundle}
            apps={this.extractApps(selectedBundle)}
            onClose={() => history.push(APPBUNDLES)}
            onEdit={() => this.setState({ showEditDialog: true })}
            onDelete={() => this.setState({ showAreYouSureDialog: true })}
            loading={loading}
          />
        )}

        {showAreYouSureDialog && (
          <AreYouSureDialog
            onClose={() => this.setState({ showAreYouSureDialog: false })}
            onDelete={() => {
              this.setState({ showAreYouSureDialog: false });
              history.push(APPBUNDLES)
              deleteAppBundle(selectedKey);
            }}
            title={selectedBundle.name}
          />
        )}

        <Table
          title="App Bundles"
          subtitle="Advanced: App Bundles allow you to group multiple apps into bundles and then apply those bundles to Device Groups. This is useful when you have a common set of apps that you'd like to apply across multiple Device Groups. App Bundles are particularly helpful with large deployments that use many Device Groups with similar sets of Approved Apps."
          addNewTitle="New App Bundles"
          onAddNewClick={() => this.setState({ showAddDialog: true })}
          headers={this.headers}
          rows={this.extractData()}
          onRowClick={key => history.push(createInfoUrl(APPBUNDLES,key))}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  apps: state.data.apps,
  contentBundles: state.data.contentBundles,
  addDialogIsShown: state.ui.addDialogIsShown,
  loading: state.ui.loading
});

const mapDispatchToProps = { deleteAppBundle };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(appbundlesPage);
